/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccesoDenegado as AccesoDenegado,
  rec_EQ as EQ,
  rec_EstructuraPrincipal as EstructuraPrincipal,
  rec_Flota as Flota,
  rec_JSXRuntime as JSXRuntime,
  rec_OrdenesTransporte as OrdenesTransporte,
  rec_PedidosTransporte as PedidosTransporte,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_ReportesTransporte as ReportesTransporte,
  rec_RutasTransporte as RutasTransporte,
  rec_puedeMovilidad as puedeMovilidad,
} from "../../runtime/index.jsx";
export function Transporte() {
  let e = (0, ReactCompiler.c)(22),
    [t, n] = (0, React.useState)(`atender`);
  if (!puedeMovilidad()) {
    let t;
    return (
      e[0] === Symbol.for(`react.memo_cache_sentinel`)
        ? ((t = <AccesoDenegado />), (e[0] = t))
        : (t = e[0]),
      t
    );
  }
  let r;
  e[1] === t
    ? (r = e[2])
    : ((r = EQ.map((e) => (
        <button
          key={e.id}
          type={`button`}
          onClick={() => n(e.id)}
          className={`-mb-px border-b-2 px-3 py-2 text-sm transition ${t === e.id ? `border-(--accent) font-medium text-(--text-h)` : `border-transparent text-(--text) hover:text-(--text-h)`}`}
          children={e.label}
        />
      ))),
      (e[1] = t),
      (e[2] = r));
  let i;
  e[3] === r
    ? (i = e[4])
    : ((i = (
        <div
          className={`flex flex-wrap gap-1 border-b border-(--border)`}
          children={r}
        />
      )),
      (e[3] = r),
      (e[4] = i));
  let a;
  e[5] === t
    ? (a = e[6])
    : ((a = t === `atender` && <PedidosTransporte />), (e[5] = t), (e[6] = a));
  let o;
  e[7] === t
    ? (o = e[8])
    : ((o = t === `ordenes` && <OrdenesTransporte />), (e[7] = t), (e[8] = o));
  let s;
  e[9] === t
    ? (s = e[10])
    : ((s = t === `reportes` && <ReportesTransporte />),
      (e[9] = t),
      (e[10] = s));
  let c;
  e[11] === t
    ? (c = e[12])
    : ((c = t === `tarifario` && <RutasTransporte />),
      (e[11] = t),
      (e[12] = c));
  let l;
  e[13] === t
    ? (l = e[14])
    : ((l = t === `flota` && <Flota />), (e[13] = t), (e[14] = l));
  let u;
  return (
    e[15] !== i ||
    e[16] !== a ||
    e[17] !== o ||
    e[18] !== s ||
    e[19] !== c ||
    e[20] !== l
      ? ((u = (
          <EstructuraPrincipal
            title={`Transporte`}
            children={
              <div
                className={`flex flex-col gap-4`}
                children={[i, a, o, s, c, l]}
              />
            }
          />
        )),
        (e[15] = i),
        (e[16] = a),
        (e[17] = o),
        (e[18] = s),
        (e[19] = c),
        (e[20] = l),
        (e[21] = u))
      : (u = e[21]),
    u
  );
}
